import { GenreCollection } from '@/modules/Collection';
import Repository from './client/TbsJsonAxiosClient';

const resource = '';

export const useGenreRepository = () => {
  /**
   * 今月の放送番組JSONを取得する
   */
  const getThisMonth = async () => {
    const { data } = await Repository.get<{ collections: Omit<GenreCollection, 'title'>[] }>(
      `${resource}/this_existence.json`
    ).catch((e) => {
      throw e;
    });
    return data;
  };

  /**
   * 来月の放送番組JSONを取得する
   */
  const getNextMonth = async () => {
    const { data } = await Repository.get<{ collections: Omit<GenreCollection, 'title'>[] }>(
      `${resource}/next_existence.json`
    ).catch((e) => {
      throw e;
    });
    return data;
  };

  return {
    getThisMonth,
    getNextMonth,
  };
};

export type GenreRepository = ReturnType<typeof useGenreRepository>;
